import React, { useState } from 'react';
import './Navbar.css';

const Navbar = ({ language, toggleLanguage, t }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="container">
        <div className="logo">
          <img src={`${process.env.PUBLIC_URL}/images/logo.png`} alt="Smiling Senegal" />
        </div>

        <button className="mobile-menu-toggle" onClick={toggleMobileMenu}>
          <i className={mobileMenuOpen ? "fas fa-times" : "fas fa-bars"}></i>
        </button>

        <div className={`nav-links ${mobileMenuOpen ? 'active' : ''}`}>
          <ul>
            <li><a href="#home" onClick={closeMobileMenu}>{t.home}</a></li>
            <li><a href="#about" onClick={closeMobileMenu}>{t.about}</a></li>
            <li><a href="#tours" onClick={closeMobileMenu}>{t.tours}</a></li>
            <li><a href="#gallery" onClick={closeMobileMenu}>{t.gallery}</a></li>
            <li><a href="#testimonials" onClick={closeMobileMenu}>{t.testimonials}</a></li>
            <li><a href="#contact" onClick={closeMobileMenu}>{t.contact}</a></li>
          </ul>
          <div className={`nav-right ${mobileMenuOpen ? 'active' : ''}`}>
            <div className="language-selector" onClick={toggleLanguage}>
              <i className="fas fa-globe"></i>
              <span>{language === 'en' ? 'EN' : 'FR'}</span>
              <i className="fas fa-chevron-down"></i>
            </div>
            <a href="#contact" className="btn-primary" onClick={closeMobileMenu}>{t.bookNow}</a>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
